<script>


  import api from "../../api";
  import func from "../../libs/functions.js";
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import OnboardingUpcoming from "./OnboardingUpcoming";
  import _ from "lodash";
  import AOS from "aos";
  import "aos/dist/aos.css";

  import config from '../../libs/config.js';
  import axios from 'axios';
  import system from '../../libs/system';
  import workspaces from '../../libs/system/services/workspaces';

  import  popupsAlertsPhone from "./popups/alerts/phone.vue";
  import  popupsAlertsSourceAndTitle from "./popups/alerts/sourceAndTitle.vue";
  import  popupsAlertsAuthentication from "./popups/alerts/authentication.vue";

  import { supabase } from "../../libs/supabaseClient";

  import { db, storage } from '../../firebase';

  export default {
    name: "leftBar",
    data() {
      return {
        func: func,
        show: false,
        hide: false,
        diff: 0,
        user: {},
        backDoorEmail: '',
        imageUrl: '',
        currentPath:'',
        isDesktop: false,
        allPurchases: [],
        countdownTimer: {},
        showMenu: {
          workspaces: false,
          deleteWs: '',
          pricingPlan: false
        }
      };
    },
    components: {
      OnboardingUpcoming,
      popupsAlertsPhone,
      popupsAlertsSourceAndTitle,
      popupsAlertsAuthentication
    },
    computed: {
      ...mapGetters("session", ["getUser", "getUserDb", "getJwt", "getRole", "getBrand", "getWhiteLabel"]),
      ...mapGetters("accounts", ["accounts"]),
      ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
      ...mapGetters("workspaceusers", ["workspaceusers"]),
      ...mapGetters("mobileMenu", ["leftMobileMenu"]),
      ...mapGetters("htmlModals", ["modals"]),
      ...mapGetters("accounts", ["accounts"]),
      ...mapGetters("menu", ["miniMenu"]),
      ...mapGetters("tags", ["tagsByName"]),
      ...mapGetters("subscriptions", ["getPaypalSubscriptions", "getSubscriptions"])
    },
    watch: {
      $route (to, from) {
        this.currentPath = this.$router.history.current.path;
      }
    },
    methods: {
      ...mapActions('session', ['login', 'setIsLoggedIn', 'setBrand']),
      ...mapActions("mobileMenu", ["toggleLeftMenu"]),
      ...mapActions("htmlModals", ["setOnboardingUpcoming", "setEditUser", "setUpgradeModal", "setPricingModal", "setCreateWorkspace", "setAutomationRulesModal", "setPhoneRequestModal", "setAuthenticationModal","setSourceTitleRequest"]),
      ...mapActions("accounts", ["setAccounts"]),
      ...mapActions("workspaces", ["setCurrentWorkspace", "setWorkspaces"]),
      ...mapActions("menu", ["toggleMiniMenu"]),
      ...mapActions('messages', ['setMessages', 'viewingMessagesArray']),
      ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
      ...mapActions("subscriptions", ["setExternalSubscriptions"]),
        image(ws, err){
          if(err) {
            return document.getElementById(ws._id).src = '/img/avatar/roboto/128/latin_'+ func.getFirstLetter(ws.name) +'.png'
          }
          return 'https://api.juphy.com/api/v1/workspaces/' + ws._id + '/avatar?accessToken=' + this.getJwt
      },
      changeWorkspace(workspace) {

/*         if(window.supabase){
          window.supabase.removeChannel(this.currentWorkspace._id)
        console.log('supbase channel removed')
        } */
        
          let payload = {
            query: {
              userId: this.getUser._id
            },
            body:{
              workspace: workspace._id
            }
          };
          system.services.user.updatePreferencesForWorkspace(payload, (err, result) => {
            if(err) console.log(err)


            window.location.reload();

/*           this.setMessages([]);
          this.setCurrentWorkspace(workspace);
          this.showMenu.workspaces = false;
          this.setLoadingApp(true);
          this.setLoadingAppReRender(true); */
          });


        
      },
      deleteWorkspace(ws, status){

        if(!status) return this.showMenu.deleteWs = ws._id //Only open
        if(status == 'no') return this.showMenu.deleteWs = ''

        const payload = {
          query: {
            workspaceId: ws._id
          }
        }

        system.services.workspaces.delete(payload, (err, workspaces) => {
          if(err) return err.message;

             location.reload(); 

        })

      },
      toInbox(){

        if(this.$router.history.current.path.includes('export')){
          window.location.href = '/inbox'
        }else{
          this.$router.push({ "path": "/inbox" });
        }
        

      },
      backDoor(){
        
        this.loading = true;
 
        axios.post(config.url + '/authentication/authenticateBy', {
        email: this.backDoorEmail } ,
        {
        headers: {
          Authorization: 'Bearer ' + this.getJwt
        }
        }).then((response) => {

               this.login({
                jwt: response.data.accessToken,
                user: response.data.user
              });
                                         
              this.setIsLoggedIn();    
              window.location.href = '/'
          
                  }).catch((error) => {
                  if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      
                      //this.$router.push({ "path": "signin" });
                      // console.log(error.response.status);
                      // console.log(error.response.headers);
                  } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      //this.$router.push({ "path": "signin" });
                      
                  }
          });
		    }
    }, 
    mounted(){

      //window._supabase = supabase;

      let realtimeActivatedWorkspaces = [
        'wise',
        'juphy',
        'yuber',
        'misrpharmacies',
        'ranchers',
        'team' //utterfly ws LTD
      ]
  
      let domain = window.location.hostname.toString();

    if(_.some(realtimeActivatedWorkspaces, (e) => this.currentWorkspace.name.toLowerCase().includes(e)) && domain !== 'localhost'){
      //window.supabase.removeAllChannels()

      window.supabase = supabase;

      window.room = window.supabase.channel(this.currentWorkspace._id)

      //supabase
/*       console.log('room1', window.room)
      window.room = window.supabase.channel(this.currentWorkspace._id)
      console.log('room2', window.room) */

/*       console.log('----------')
      console.log(window.supabase.realtime.isConnected())
      console.log(window.supabase.realtime.connectionState())
      console.log('----------') */


     
      //supabase
      window.room.subscribe((status) => {
      if (status === 'SUBSCRIBED') {
          console.log(status);

/*           console.log('----------')
      console.log(window.supabase.realtime.isConnected())
      console.log(window.supabase.realtime.connectionState())
      console.log('----------') */


          window.supabase.channel(this.currentWorkspace._id).on('broadcast', { event: 'refresh' }, (data) => { 
          if(window.location.href.toString().includes('conversation')){
              //supabase
              window.room.send({
                type: 'broadcast',
                event: 'opened',
                payload: { 
                  date: Date.now(),
                  messageId: window.location.href.toString().split('=')[1],
                  user: this.getUser, 
                  to: data.payload.to
                  },
              })
          }
          //console.log(data.payload)
        })


        //supabase
        window.supabase.channel(this.currentWorkspace._id).on('broadcast', { event: 'opened' }, (data) => { 
          if(data.payload.to && this.getUser._id == data.payload.to._id && !window.location.href.toString().includes('conversation')){
              this.viewingMessagesArray({
              type: 'create',
              data: data.payload
            })
          }

          if(!data.payload.to){
            this.viewingMessagesArray({
            type: 'create',
            data: data.payload
          })
          }

        })

        //supabase
        window.room.send({
          type: 'broadcast',
          event: 'refresh',
          payload: { 
            date: Date.now(),
            to: this.getUser
          },
        })

        //supabase
        window.addEventListener("beforeunload", () => { 
          window.room.send({
            type: 'broadcast',
            event: 'closed',
            payload: { 
              messageId: null,
              userId: this.getUser._id
              },
          })
        });
        
      }
      })

    
    }else{
      console.log('zarsuzarpazarbasenonexist')
      window.room = {
        send: ((e) => {
          console.log('room ', e)
        })
      }
      window.supabase = {
        channel: ((e) => {
          console.log('Channel: ', e)
          return { 
            on: ((e) => {
              console.log('on: ',e)
            })
           }
        })
      }
    }



      let getAdminPaid = _.some(this.workspaceusers, (workspaceuser) => {
        if(workspaceuser.user.payments && workspaceuser.user.payments.length) return workspaceuser
      })

      if(!this.accounts.length && !getAdminPaid && this.workspaces.length < 2){
        this.setAuthenticationModal(true);
      }

if(!this.getWhiteLabel){
  //console.log(this.getUser.name)
  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "a23xtzcb",
    name: this.getUser.name, // Full name
    email: this.getUser.email // Email address
    //created_at: this.user.createdAt // Signup date as a Unix timestamp
  };

  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/a23xtzcb'
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/a23xtzcb';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
}


      //Burada adamın active accountslarını say ona göre engelle
      this.allPurchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()
      this.allPurchases = this.allPurchases.concat(this.getSubscriptions)
      let allActiveAccounts = _.filter(this.accounts, (a) => {
        if(a.tags && !a.tags.includes(this.tagsByName['Passive']._id)){
          return a
        }
      })


      let totalChannelLimit = _.sumBy(this.allPurchases, 'channelLimit')

      //Geçici ek
      if(this.currentWorkspace.pricingPlan == "Business"){
        totalChannelLimit = totalChannelLimit + 15
      }

      if(this.currentWorkspace.pricingPlan == "Enterprise"){
        totalChannelLimit = totalChannelLimit + 300
      }


      
/*       if(this.currentWorkspace.pricingPlan == 'Trial' && (!this.getUserDb.phones || this.getUserDb.phones && !this.getUserDb.phones.length)){
        this.setPhoneRequestModal(true);
      } */
      
/*       if(this.currentWorkspace.pricingPlan == 'Trial' && (!this.getUserDb.title)){
        this.setPhoneRequestModal(true);
      }

      if(!this.getUserDb.title && this.currentWorkspace.pricingPlan != 'Trial'){
        this.setSourceTitleRequest(true);
      } */

      //burada trial bittiyse engelle
      //1219200000 14 days
      //609600000 7 days
/*       setTimeout(() => {

      window.hj('identify', this.getUser._id, { email: this.getUser.email,  is_customer: (this.currentWorkspace.pricingPlan == 'Trial') ? false : true });

        if(this.currentWorkspace.pricingPlan == 'Trial' && this.diff >= 1219200000 && !this.getWhiteLabel){
          console.log('zrr')
            window.trialFinished = setInterval(() => {
              if(this.currentWorkspace.pricingPlan == 'Trial' && this.diff >= 1219200000){
                          this.$router.push('/upgrade')
              }else{
                clearInterval(window.trialFinished)
              }
            }, 15000);
        }
      }, 15000); */

/*       if(this.currentWorkspace.pricingPlan == 'Trial'){
            var phDiv = document.createElement("div");
            phDiv.id = 'phdiv';
            phDiv.style.height = '42.4px';
            phDiv.innerHTML = '<div style="width: 100%;background: #da552f; padding: 0.8rem; text-align: center; color: #fff; font-weight: bold; position:fixed; z-index:99999999;">Special 30% discount for Product Hunters and 30-Day Money Back Guarantee! <a style="color: #ffffff; text-decoration: underline;" href="/upgrade?code=PH30">Upgrade Now! (DISCOUNT CODE: PH30)</a> </div>';
            document.body.prepend(phDiv);
      } */

setTimeout(() => {

/* if(this.currentWorkspace.pricingPlan == 'Trial' && !this.getWhiteLabel){
    var newPriceElement = document.createElement("div");
    newPriceElement.innerHTML = '<div style="text-align: center; background: #212623; width: 100%; color: #e6e6e6; padding: 1rem; 2rem;">We will update prices on the 20th of June 2022. Prices will increase to $25/mo (Starter), and $45/mo (Growth) per person. This is a good opportunity to benefit from the current prices. </div>';
    document.getElementsByTagName('body')[0].prepend(newPriceElement); 
  } */

if(this.currentWorkspace.pricingPlan == 'Trial' && this.diff <= 1219200000 && !this.getWhiteLabel){

      let seconds = (((this.user.createdAt + 1219200000) / 1000) - Math.floor(Date.now() / 1000));
      //let seconds = this.getUser.createdAt / 1000
      window.countdownTimer = setInterval(() => {
        var days        = Math.floor((seconds/24/60/60));
        var hoursLeft   = Math.floor((seconds) - (days*86400));
        var hours       = Math.floor(hoursLeft/3600);
        var minutesLeft = Math.floor((hoursLeft) - (hours*3600));
        var minutes     = Math.floor(minutesLeft/60);
        var remainingSeconds = Math.floor(seconds % 60);
        let pad = (n) => {
          return (n < 10 ? "0" + n : n);
        }
        document.getElementById('countdown').innerHTML = pad(days) + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm'

        if (seconds <= 0) {
          clearInterval(window.countdownTimer);
          document.getElementById('countdown').innerHTML = "Completed";
        } else {
          seconds--;
        }

        $('#countdown')
          .transition('pulse')
        ;
      }, 1000);
}
}, 17000)


$('.item.popup')
  .popup({
    position: 'right center',
    variation: 'inverted small'
  })
;

              !function(w,d,i,s){function l(){if(!d.getElementById(i)){var f=d.getElementsByTagName(s)[0],e=d.createElement(s);e.type="text/javascript",e.async=!0,e.src="https://canny.io/sdk.js",f.parentNode.insertBefore(e,f)}}if("function"!=typeof w.Canny){var c=function(){c.q.push(arguments)};c.q=[],w.Canny=c,"complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)}}(window,document,"canny-jssdk","script");

          Canny('initChangelog', {
            appID: '5bd0bea783508869f86a0d89',
            position: 'top',
            align: 'left',
        });


      this.isDesktop = window.juphyDesktopApp;



        io.on('users', (data) => { 
          for (const dat of data) {
             let index = _.findIndex(this.workspaceusers, { user: { _id:  dat._id }});
            if(index !== -1){
              let staticObject = Object.assign({}, this.workspaceusers[index])
              staticObject.online = true;
              this.$set(this.workspaceusers, index, staticObject);
            }
          }
        });


    },
    created() {


      

      let payload = {
        query: {
          userId: this.getUser._id
        }
      }

      system.services.user.getUserById(payload, (err, res) => {
        if (err) console.log(err)

        this.diff = (Math.floor(Date.now()) - res.createdAt)
        this.user = res

        let workspaceuser = _.find(this.workspaceusers, (workspaceuser) => workspaceuser.user.brand )
          if(workspaceuser){
            workspaceuser.user.brand.loaded = true
            this.setBrand(workspaceuser.user.brand);
          }

          let cname = _.chain(this.getBrand).get('cname.0.name').defaultTo('').value().replaceAll('.','')
            if(cname.length){
              db.collection('domains')
              .doc(cname)
              .get()
              .then(snapshot => {
                const document = snapshot.data()
                console.log(document)
                this.imageUrl = document.url
              }).catch((err)=>{
                this.imageUrl = '/img/logo_dark2.png'
              })
            }else{
              this.imageUrl = '/img/logo_dark2.png'
            }

      })


        if(!this.currentWorkspace.color){
          this.currentWorkspace.color = 'rgb(53, 59, 72)'
          this.setCurrentWorkspace(Object.assign({}, this.currentWorkspace))
        }

      let getAdminsAccounts = _.find(this.workspaceusers, (workspaceuser) => {
          if(workspaceuser.tags.includes(this.tagsByName['Admin']._id)) return workspaceuser
      });


        let appsumoPayments = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()

        let filteredPlans = _.filter(appsumoPayments, (p) => p.package == 'Business' || p.package == 'Growth' || p.package == 'Starter' ||  p.package == 'Agency' ||  p.package == 'Agency Plus' || p.package == 'Enterprise')

        if(appsumoPayments.length) this.currentWorkspace.pricingPlan = 'Business'

        if(filteredPlans.length) this.currentWorkspace.pricingPlan = filteredPlans[0].package
        
        this.showMenu.pricingPlan = true
  

      this.currentPath = this.$router.history.current.path;
    
     
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      )
        return (this.hide = true);

      AOS.init({
        once: true,
        offset: 0
      });
    },
    destroyed(){
        clearInterval(window.countdownTimer)
        //clearInterval(window.trialFinished)
      }
  };

</script>

<template>

<div :style="(currentPath == '/inbox') ? 'height: 100vh;' : 'height: auto;'" class="three wide stretched column">


<!-- <popupsAlertsPhone v-if="modals.phoneRequest"></popupsAlertsPhone>  -->

<!-- <popupsAlertsSourceAndTitle v-if="modals.sourceTitleRequest"></popupsAlertsSourceAndTitle> -->

<!-- <popupsAlertsAuthentication v-if="modals.authentication"></popupsAlertsAuthentication> -->


<div class="ui grid">
  <div :style="{background: currentWorkspace.color }" style="padding: 0; position: vertical;" class="four wide column">
  <div style="background: rgba(0,0,0,0.3); z-index:11; padding: 0; position: absolute; top:0;right:0;left:0;bottom:0;">
    <div class="ui vertical fluid inverted icon menu">
      <a v-for="workspace in workspaces" :key="workspace._id" 
          @click="changeWorkspace(workspace)" :style="{ 'padding': (miniMenu.toggle) ? '10px 5px': '', 'background': (workspace._id == currentWorkspace._id) ? currentWorkspace.color : 'transparent'}"
          :class="(workspace._id == currentWorkspace._id) ? 'active':''" class="item popup" 
          :title="workspace.name"
          :data-content="workspace.name">
          <div v-if="!miniMenu.boing" data-aos="fade" v-bind:style="{ 'height' : (miniMenu.toggle)? '55px' : 'auto' }"
            style="vertical-align: middle; display:block">
            <img :id="workspace._id" :style="{'background': 'transparent','vertical-align' : 'middle', 'margin': (miniMenu.toggle) ? '0': '.25em'}"
            :src="image(workspace)" @error="image(workspace, true)" style="width:32px;height:32px; border-radius: 5px;" class="ui avatar image">
          </div>
        </a>
        <a v-show="!getWhiteLabel" href="#" class="item popup" @click="setCreateWorkspace(true)" data-content="Add Workspace/Brand">
          <div style="background: transparent" class="ui icon black button">
            <i class="plus icon"></i>
          </div>
        </a>
    </div>
  </div>
  </div>
<div @mouseover="show = true" @mouseout="show = false" style="
 transition: 0.5s;" v-bind:style="{ padding: (leftMobileMenu) ? '0px' : false, 'background': currentWorkspace.color  }"
    v-bind:class="(leftMobileMenu) ? 'ui sidebar left visible leftMenu' : (miniMenu.toggle) ? 'one wide computer two wide tablet only column leftMenu' : 'twelve wide computer tablet only column leftMenu' ">
<div v-if="isDesktop" style="height: 2px;"></div>
 <div class="dragable" v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu top'">
          <a @click="(showMenu.workspaces) ? showMenu.workspaces = false : showMenu.workspaces = true" style="padding-top: 3px;"
          class="item popup">
          <div v-if="!miniMenu.boing" data-aos="fade" v-bind:style="{ 'height' : (miniMenu.toggle)? '55px' : 'auto' }"
            style="vertical-align: middle;display:inline-block">
            <span class="workspaceName">{{(currentWorkspace.name.length > 13 )? currentWorkspace.name.substring(0, 10)
              + '...' : currentWorkspace.name }}</span>
                          <p v-show="!getWhiteLabel" v-if="showMenu.pricingPlan" 
            style="
            font-size: 12px;
            font-style: italic;
            margin-top: 5px;
            border-radius: 5px;
            margin-bottom: 0;
            ">
            {{currentWorkspace.pricingPlan}} 
            <span id="countdown"></span>
            </p>
          </div>

          <i v-show="!miniMenu.toggle && !showMenu.workspaces" style="margin: .5em 0 0 .5em;" class="ellipsis vertical icon"></i>
          <i v-show="!miniMenu.toggle && showMenu.workspaces" style="margin: .5em 0 0 .5em;" class="angle up icon"></i>
        </a>

          <div style="border-bottom: 1px solid rgba(255,255,255,.05); height: 10px; display:block; margin: 0 -1rem;  "></div>
      </div>

      <div v-if="showMenu.workspaces" data-aos="fade-right" v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu inside'">
        <div class="item popup">
        <span v-show="miniMenu.boing" class="popupz">{{getUser.name}}</span>
          <div v-if="!miniMenu.boing" data-aos="fade" v-bind:style="{ 'height' : (miniMenu.toggle)? '55px' : 'auto' }"
            style="display:inline-block">
            {{getUser.name}}
            <p style="font-size:12px; font-style: italic;">{{getUser.email}}</p>
          </div>
        </div>
        <router-link  class="item popup" to="/account">
          <span v-if="!miniMenu.boing" data-aos="fade">Account Settings</span>
        </router-link>
<!--         <router-link v-if="getRole.name == 'Admin'" v-show="!getWhiteLabel"  class="item popup" to="/upgrade">
          <span v-if="!miniMenu.boing" data-aos="fade">Upgrade</span>
        </router-link> -->
<!--         <a href="https://juphy.com/pricing" target="_blank" v-if="getRole.name == 'Admin'" v-show="!getWhiteLabel"  class="item popup" >
          <span v-if="!miniMenu.boing" data-aos="fade">Upgrade</span>
        </a> -->
<!--         <a v-if="getRole.name == 'Admin'" v-show="!getWhiteLabel" @click="setUpgradeModal(true)" class="item popup">
          <span v-if="!miniMenu.boing" data-aos="fade">Upgrade</span>
          <span v-show="miniMenu.boing" class="popupz">Upgrade</span>
        </a> -->
<!--         <router-link v-show="!getWhiteLabel" class="item popup" to="/notifications">
          <span v-if="!miniMenu.boing" data-aos="fade">Slack Notifications</span>
          <span v-show="miniMenu.boing" class="popupz">Slack Notifications</span>
        </router-link> -->
<!--          <a v-if="getRole.name == 'Admin'" v-show="!getWhiteLabel" @click="setPricingModal(true)" class="item popup">
          <span v-if="!miniMenu.boing" data-aos="fade">Billing</span>
          <span v-show="miniMenu.boing" class="popupz">Billing</span>
        </a> -->
        <a href="/logout" class="item popup">
        <span v-show="miniMenu.boing" class="popupz">Adiós 👋</span>
          <span v-if="!miniMenu.boing" data-aos="fade">Logout</span>
        </a>

<!--         <h5  class="ui inverted header">Workspaces</h5>
          <a v-for="workspace in workspaces" :key="workspace._id" v-show="showMenu.workspaces && workspace._id != currentWorkspace._id"
          @click="changeWorkspace(workspace)" :style="{ 'padding': (miniMenu.toggle) ? '10px 5px': ''}"
          class="item popup">
          <div v-if="!miniMenu.boing" data-aos="fade" v-bind:style="{ 'height' : (miniMenu.toggle)? '55px' : 'auto' }"
            style="vertical-align: middle;display:block">
            <img :style="{'background': 'transparent','vertical-align' : 'middle', 'margin': (miniMenu.toggle) ? '0': '.25em'}"
            :src="image(workspace)" style="width:18px;height:18px;" class="ui avatar image">
            <span class="workspaceName" style="vertical-align: middle;">{{workspace.name.substring(0, 14)}}</span>
            <span v-on:click.stop @click="deleteWorkspace(workspace, null)" style="font-style: italic; font-size: 10px; float:right;"><i class="x icon"></i></span>
          </div>
          <div v-if="workspace._id == showMenu.deleteWs" style="border-bottom: 2px solid rgba(255,255,255, .6); display: block; padding: 1rem 0;">
            <p>Are you sure? </p>
            <div class="ui mini fluid buttons">
              <button v-on:click.stop @click="deleteWorkspace(workspace, 'no')" class="ui button active">No</button>
              <button v-on:click.stop @click="deleteWorkspace(workspace, 'yes')" class="ui red button">Yes</button>
            </div>
          </div>
        </a>
          <a v-if="getRole.name == 'Admin' || getRole.name == 'Moderator'" v-show="showMenu.workspaces" @click="setCreateWorkspace(true)" style="font-size: 12px;" class="icon item">
          <span v-if="!miniMenu.boing" data-aos="fade">Create New Workspace</span>
          <i class="long arrow alternate right icon"></i>
          </a> -->


      </div>

    <div  v-bind:style="{ padding: (leftMobileMenu) ? '10px' : '0px' }">

      <div v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu'">
        
        <a @click="toInbox();" class="item popup">
          <span v-if="!miniMenu.boing" data-aos="fade"><i style="vertical-align: bottom;" class="inbox icon"></i> Inbox</span>
        </a>

         
         <div :class="{ 'active': (currentPath == '/inbox' || currentPath == '/inbox2')}" class="subMenu" style="margin-left: 10px; border-left: 1px dotted rgba(255,255,255,0.3);">

           <a style="display: inline-block;padding-left: 5px;" @click="setAutomationRulesModal(true)" class="item"> Automation Rules</a>
         </div>
         
         <div v-if="getUser.email.includes('tenac') || getUser.email.includes('sanofi') || getUser.email.includes('juphy')" :class="{ 'active': (currentPath == '/inbox' || currentPath == '/inbox2' || currentPath == '/export')}" class="subMenu" style="margin-left: 10px; border-left: 1px dotted rgba(255,255,255,0.3);">

          <router-link style="display: inline-block;padding-left: 5px;" class="item popup"
          to="/export">
          <span v-if="!miniMenu.boing" data-aos="fade">Export Comments</span>
          </router-link>

          

         </div>

<!--         <router-link v-if="(getUser.email == 'eyup@juphy.com' || getUser.email == 'erdi@juphy.com')" class="item popup"
          to="/inbox2">
          <span v-if="!miniMenu.boing" data-aos="fade"><i style="vertical-align: bottom;" class="inbox icon"></i> Inbox v2</span>
        </router-link> -->

        <router-link v-if="getRole.name == 'Admin' || getUser.email.includes('estee') "  class="item popup" to="/statistics">
          <span v-if="!miniMenu.boing" data-aos="fade"><i class="chart bar outline icon"></i> Reports</span>
          <span v-show="miniMenu.boing" class="popupz">Reports</span>
        </router-link>

        <router-link  class="item popup" to="/audience">
          <span data-aos="fade"><i class="users icon"></i> Contacts</span>
        </router-link>

<!--         <router-link  class="item popup" to="/knowledge-base">
          <span data-aos="fade"><i class="file alternate icon"></i> Knowledge Base</span>
        </router-link> -->

<!--         <router-link  class="item popup" to="/campaigns">
          <span data-aos="fade"><i class="send icon"></i> Campaigns</span>
        </router-link> -->
      </div>

      <div style="border-bottom: 1px solid rgba(255,255,255,.05); height: 1px; display:block; margin: 0 -1rem;  "></div>

<h5 v-if="!miniMenu.boing" style="color: rgba(255,255,255, .8); margin-top: 1rem;" class="ui inverted header">Settings</h5>
      <div v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu'">
        <router-link  class="item popup" to="/widget">
          <span v-if="!miniMenu.boing" data-aos="fade"><i style="font-size: 17px; margin: 0 .25rem 0 0;" class="fab fa-shopify"></i>  AI Assistant</span>
        </router-link>
<!--         <router-link  class="item popup" to="/knowledge">
          <span v-if="!miniMenu.boing" data-aos="fade"><i class="book icon"></i>  Knowledge-base</span>
        </router-link> -->
        <router-link  class="item popup" to="/accounts">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="th list icon"></i> Social Channels</span>
        </router-link>
        <router-link  class="item popup" to="/team">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="users icon"></i> Team</span>
        </router-link>
<!--         <router-link  class="item popup" to="/tracking">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="filter icon"></i> Conversion Tracking</span>
        </router-link> -->
<!--         <router-link  class="item popup" to="/tracking">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="comments outline icon"></i> Social Chat Widget</span>
        </router-link> -->
        <router-link class="item popup" to="/workspace">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="window maximize outline icon"></i> Workspace</span>
        </router-link>
<!--         <router-link class="item popup" to="/config">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="window maximize outline icon"></i> Chatbot Settings</span>
        </router-link> -->
<!--         <router-link v-show="!getWhiteLabel"  class="item popup" to="/whitelabel">
          <span v-if="!miniMenu.boing" data-aos="fade"> <i class="ticket alternate icon"></i> White-label</span>
        </router-link> -->
      </div>

<!--       <div style="border-bottom: 1px solid rgba(255,255,255,.05); height: 1px; display:block; margin: 0 -1rem;  "></div>

      

          <div v-if="!miniMenu.boing" v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu'">
        
          <a v-for="workspaceuser in workspaceusers" :key="workspaceuser._id" class="item popup">   
                     
        
          <div  data-aos="fade" style="vertical-align: middle;display:inline-block">
            <span class="workspaceName"><i :class="(workspaceuser.online) ? 'teal' : ''" class="circle small icon"></i>   {{workspaceuser.user.name}}</span>
          </div>
        </a>
      </div> -->

      <div v-show="!getWhiteLabel" style="border-bottom: 1px solid rgba(255,255,255,.05); height: 1px; display:block; margin: 0 -1rem;  "></div>

      <h5 v-if="!miniMenu.boing" v-show="!getWhiteLabel" style="color: rgba(255,255,255, .8); margin-top: 1rem;" class="ui inverted header">Product</h5>



            <div v-if="!miniMenu.boing" v-show="!getWhiteLabel" v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu'">


              <router-link class="item"  to="/upgrade-shopify">
                <span data-aos="fade">
                  <i class="angle double up icon"></i>
                  Upgrade</span>
              </router-link>

<!--         <a href="https://apps.shopify.com/juphy" target="_blank" class="item"> <span>  <i class="angle double up icon"></i> Upgrade </span>
              </a> -->

              <a href="#" class="item" data-canny-changelog> <span> <i class="bullhorn icon"></i> Change Logs </span>
              </a>
        <router-link class="item"  to="/community/feature-requests">
          <span v-if="!miniMenu.boing" data-aos="fade">
              <i class="tasks icon"></i>
             Public Roadmap</span>
          <p v-if="!miniMenu.boing" style="font-size:11px; margin-top:5px;">Upvote or Create Feature Requests, Give Feedback, Report Bugs.</p>
        </router-link>

</div>

<div class="ui basic segment">
  <img class="ui image opacit" style=" width: 105px;" :src="imageUrl">
  <span v-show="!getWhiteLabel" style=" display: block; color: rgba(255,255,255, .4); font-size:11px; font-weight: 300; margin-top:5px;">© Juphy 2024 · v2.98</span>
</div>
      
    <!--   ADMIN   -->
    <div v-if="getUser.tags && getUser.tags.indexOf(tagsByName['Developer']._id) != -1" v-bind:class="(miniMenu.toggle) ? 'ui vertical fluid inverted icon menu' : 'ui vertical fluid inverted menu'">
      <div class="item">
        <div class="ui fluid inverted input">
          <input style="background: transparent; color: #fbfbfb;" type="text" v-model="backDoorEmail" v-on:keyup.enter="backDoor()">
        </div>
      </div>
    </div>

    </div>
  </div>
  </div>
  </div>
</template>


<style>
.Canny_BadgeContainer .Canny_Badge::before { 
  content: "⚡New";
}
.Canny_BadgeContainer .Canny_Badge {
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 10px;
  background-color: transparent;
  font-size: 10px;
  color: #fff;
  padding: 3px 5px;
  content: normal;
  border:none;
}

.subMenu{
  height: 0px;
  overflow: hidden;
  transition: 0.3s;
}
.subMenu.active{
  height: 28px;
  transition: 0.3s;
}

.ui.vertical.inverted.menu .item:before {
    background: rgba(255,255,255,.0);
}

.opacit{
  opacity: .9;
}

.opacit:hover {
  opacity: 1;
}

.ui.inverted.menu .dropdown.item:hover, .ui.inverted.menu .link.item:hover, .ui.inverted.menu a.item:hover, .ui.link.inverted.menu .item:hover {
    background: rgba(255,255,255,.0);
    color: #fff;
    padding-left: 0.5rem;
}

		.ui.inverted.menu{
			background: rgba(255,255,255,0.0) !important;
		}

    .ui.inverted.menu .item, .ui.inverted.menu .item>a:not(.ui) {
    background: 0 0;
    color: rgba(255,255,255,.75);
}

.hoverCreateWorkspace:hover {
  color: #ffffff !important;
}

.popup:hover > .popupz{
  display: block;
}

.popupz {
  display: none;
  position: absolute;
  background: #3960BD;
  z-index: 99999;
  top: 0px;
  left: 49px;
  border-radius: 0 5px 5px 0;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  line-height: 40px;
  padding: 0px 10px;
}

.popupz.workspace{
    line-height: 48px;
}

  .workspaceName {
    text-transform: capitalize;
  }

  .ui.vertical.menu .item {
    min-height: 10px;
    transition: 0.5s;
    padding: 0.5rem 0.2rem;
  }

  .ui.vertical.menu .router-link-active.item {
    border-radius: 3px !important;
    padding-left: 0.6rem !important;
    color: rgba(255,255,255,1);
  }

  .ui.vertical.menu.fluid.top {
      padding: 0 !important;
  }

  .ui.inverted.menu.inside{
    padding: 1rem;
    background: rgba(28, 29, 31, 0.57) !important;
    box-shadow: rgba(0, 0, 0, 0.5) 3px 3px 20px !important;
}

  .leftMenu a{
    color: #a7adba;
    /* fallback for old browsers 3960bd  353b48*/ 
  }

  .item .cog.icon{
    color: rgba(255, 255, 255, 0.47);
  }
  .item .cog.icon:hover{
    color: rgba(255, 255, 255, 0.87);
  }
  /* .one.wide.computer.tablet.only.column{
max-width: 100px;
} */

</style>



// WEBPACK FOOTER //
// src/components/dashboard/leftBar.vue